String.prototype.urlFormat = function() {
    try {
        // let arr = location.href.split("?").length>1 && location.href.split("?")[1].split("&")
        let arr = (this.split("?").length > 1 && this.split("?")[1].split("&")) || []
        let appInfo = {}
        arr.forEach((ele) => {
            appInfo[ele.split("=")[0]] = ele.split("=")[1]
        })
        return appInfo
    } catch(e) {
        console.log(e)
        return false
    }
}

window.encodeSearchKey = function(key) {
    const encodeArr = [{
        code: '%',
        encode: '%25'
    }, {
        code: '?',
        encode: '%3F'
    }, {
        code: '#',
        encode: '%23'
    }, {
        code: '&',
        encode: '%26'
    }, {
        code: '=',
        encode: '%3D'
    }];
    return key.replace(/[%?#&=]/g, ($, index, str) => {
        for (const k of encodeArr) {
            if (k.code === $) {
                return k.encode;
            }
        }
    });
}
